import { Component, Inject } from "@angular/core";

@Component({
    selector: "instructions-dialog",
    templateUrl: "instructions-dialog.html",
  })
  export class InstructionsDialog {
    constructor() {}
  }